import { styles } from '@app/services/app-styles.service';

const stepper = {
    stepPanels: {
        padding: styles().paddingSm + ' ' + styles().paddingSm,
    },
    stepNumber: {
        activeBackground: styles().primary,
        activeColor: styles().primaryBackground,
        activeBorderColor: styles().primary,
    },
};

export default stepper;
